module.exports = __webpack_public_path__ + "static/media/04.174192e3.png";